import React from "react";
import {
  BASE_CUSTOM_MAP_GEOMETRY_TYPE,
  DEFAULT_MAP_STYLES,
  POINT_MAP_ICON,
} from "common/constants";
import { IconWrapper } from "../__styles__/ObjectTypePreviewIcon";
import LineIcon from "./LineIcon";
import PointIcon from "./PointIcon";
import PolygonIcon from "./PolygonIcon";

type ObjectTypePreviewIconProps = {
  geometryType: BASE_CUSTOM_MAP_GEOMETRY_TYPE;
  fillColor?: string;
  fillOpacity?: number;
  lineColor?: string;
  lineOpacity?: number;
  lineWidth?: number;
  iconType?: POINT_MAP_ICON;
  size?: number;
};

const ObjectTypePreviewIcon = ({
  geometryType,
  fillColor = DEFAULT_MAP_STYLES.fillColor,
  fillOpacity = DEFAULT_MAP_STYLES.fillOpacity,
  lineColor = DEFAULT_MAP_STYLES.lineColor,
  lineOpacity = DEFAULT_MAP_STYLES.lineOpacity,
  lineWidth = DEFAULT_MAP_STYLES.lineWidth,
  iconType = DEFAULT_MAP_STYLES.icon,
  size,
}: ObjectTypePreviewIconProps) => {
  const wrapperStyle = size ? { width: size, height: size } : undefined;
  const renderIcon = () => {
    switch (geometryType) {
      case "point":
        return (
          <PointIcon
            iconType={iconType}
            fillColor={fillColor}
            fillOpacity={fillOpacity}
            lineColor={lineColor}
            size={size}
          />
        );
      case "line":
        return (
          <LineIcon
            lineColor={lineColor}
            lineOpacity={lineOpacity}
            lineWidth={lineWidth}
            size={size}
          />
        );
      case "polygon":
        return (
          <PolygonIcon
            fillColor={fillColor}
            fillOpacity={fillOpacity}
            lineColor={lineColor}
            lineOpacity={lineOpacity}
            lineWidth={lineWidth}
            size={size}
          />
        );
      default:
        return (
          <PointIcon
            iconType={iconType}
            fillColor={fillColor}
            fillOpacity={fillOpacity}
            lineColor={lineColor}
            size={size}
          />
        );
    }
  };

  return <IconWrapper style={wrapperStyle}>{renderIcon()}</IconWrapper>;
};

export default ObjectTypePreviewIcon;
